export class StockAdjustment {
    constructor(public AjID?, public AjDT?, public SID?, public SN?, public Cat?, public Qty?, public ScID?, public ScN?, public AjType?, public Rmk?) { }
}